import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  fill2542d4m9l93pn as fill,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  toByte4i43936u611k as toByte,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toShort36kaw0zjdq3ex as toShort,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  createThis2j2avj17cvnv2 as createThis,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  protoOf180f3jzyo7rfj as protoOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  isInterface3d6p8outrmvmk as isInterface,
  numberToLong1a4cndvg6c52s as numberToLong,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  toHexString18s73ly43cg6d as toHexString,
  toHexString22imn3z7nuei9 as toHexString_0,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  unsupported198cz39rr1ztw as unsupported,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  MemorySyncStream1uv927me2xl9s as MemorySyncStream,
  write81fg3kayjaelgo as write8,
  AsyncGetLengthStream219k26r6v6js2 as AsyncGetLengthStream,
  AsyncGetPositionStream2f8n5516y4rp7 as AsyncGetPositionStream,
  asyncStreamWriter3ock1ljgyrdbd as asyncStreamWriter,
  openSync2m3qn99fqytu0 as openSync,
  AsyncOutputStreamkoco1dsjo5gm as AsyncOutputStream,
  toAsync26jtc2k5wi4gn as toAsync,
  toAsync2pa2d6thtq8t4 as toAsync_0,
  write$default33b74pnsnzha9 as write$default,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_0,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  SimpleRingBuffer1a4k3g2va6i8y as SimpleRingBuffer,
  getU16LE2cizldw8qp53x as getU16LE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import { runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions } from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  CRC32_getInstance38eqfkdpicymh as CRC32_getInstance,
  Adler32_instance33daqpim0ep9p as Adler32_instance,
} from './korlibs-checksum-root-korlibs-checksum.mjs';
import { extract2vhru1ihy4ogl as extract } from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var clz32 = Math.clz32;
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    this.w21_1 = 8388608;
    this.x21_1 = 131072;
  }
}
class Companion_0 {
  constructor() {
    this.y21_1 = -1;
    this.z21_1 = -2;
    this.a22_1 = 1023;
    this.b22_1 = 16;
    this.c22_1 = 288;
    this.d22_1 = true;
    this.e22_1 = true;
    this.f22_1 = 10;
  }
}
class SlidingWindowWithOutput {
  constructor(sliding, out, flushSize, extraSize) {
    flushSize = flushSize === VOID ? 8388608 : flushSize;
    extraSize = extraSize === VOID ? 131072 : extraSize;
    this.v22_1 = sliding;
    this.w22_1 = out;
    this.x22_1 = flushSize;
    this.y22_1 = extraSize;
    this.z22_1 = FixedSizeByteArrayBuilder.w23(this.x22_1 + this.y22_1 | 0);
  }
  c23() {
    return this.z22_1.b23_1 >= this.x22_1;
  }
  r23(distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this.v22_1.b24(distance);
        this.z22_1.tu(toByte(v));
      }
       while (inductionVariable < length);
  }
  v23(bytes, offset, len) {
    this.z22_1.ru(bytes, offset, len);
    this.v22_1.c24(bytes, offset, len);
  }
  s23(byte) {
    this.z22_1.tu(byte);
    this.v22_1.d24(get_unsigned(byte));
  }
}
class CompressionMethod {}
function uncompress(i, o, $completion) {
  unsupported();
}
class IDeflaterInternal {}
function uncompress_0(i, o, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_0.bind(VOID, this, i, o), $completion);
}
class DeflaterPortable {
  constructor(windowBits) {
    Companion_getInstance_1();
    this.s22_1 = windowBits;
  }
  e24(reader, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp.bind(VOID, this, reader, out), $completion);
  }
}
class Companion_1 extends DeflaterPortable {
  constructor() {
    Companion_instance_1 = null;
    super(15);
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    // Inline function 'kotlin.apply' call
    var this_0 = new Int32Array(288);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.compression.deflate.Companion.FIXED_TREE.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0[n] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0[n_0] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this_0[n_1] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        this_0[n_2] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp.h23_1 = tmp_0.o23(this_0);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(32);
    while (tmp_3 < 32) {
      tmp_4[tmp_3] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1.i23_1 = tmp_2.o23(tmp_4);
    var tmp_5 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_5.j23_1 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    var tmp_6 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_6.k23_1 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    var tmp_7 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_7.l23_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    var tmp_8 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_8.m23_1 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    var tmp_9 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_9.n23_1 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  }
}
class HuffmanTree {
  constructor() {
    this.g22_1 = new Int32Array(1024);
    this.h22_1 = new Int32Array(1024);
    this.i22_1 = new Int32Array(1024);
    this.j22_1 = 0;
    this.k22_1 = 1023;
    this.l22_1 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(1024);
    while (tmp_0 < 1024) {
      tmp_1[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.m22_1 = tmp_1;
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(1024);
    while (tmp_3 < 1024) {
      tmp_4[tmp_3] = 0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2.n22_1 = tmp_4;
    this.o22_1 = new Int32Array(17);
    this.p22_1 = new Int32Array(17);
    this.q22_1 = new Int32Array(17);
    this.r22_1 = new Int32Array(288);
  }
  p23(reader) {
    reader.g24(10);
    var node = this.k22_1;
    if (true && reader.j24() >= 10) {
      var bits = reader.h24(10);
      var raw = this.m22_1[bits];
      var value = toShort(raw);
      var len = raw >> 16;
      if (len > 0) {
        reader.i24(len);
        if (value === -2) {
          node = this.n22_1[bits];
        } else {
          return value;
        }
      }
    }
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.e23()) {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
          var this_0 = node;
          tmp = this.i22_1[this_0];
        } else {
          // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
          var this_1 = node;
          tmp = this.h22_1[this_1];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
        var this_2 = node;
        tmp_0 = this.g22_1[this_2] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var this_3 = node;
    return this.g22_1[this_3];
  }
  q23(codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    fill(this.o22_1, 0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          // Inline function 'kotlin.error' call
          var message = 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException.h5(toString(message));
        }
        var _array__4zh2yp = this.o22_1;
        _array__4zh2yp[codeLen] = _array__4zh2yp[codeLen] + 1 | 0;
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 16)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count = this.o22_1[n_0];
        this.p22_1[n_0] = currentOffset;
        this.q22_1[n_0] = currentOffset;
        currentOffset = currentOffset + count | 0;
      }
       while (inductionVariable_0 < 16);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var _array__4zh2yp_0 = this.q22_1;
        var _unary__edvuaz = _array__4zh2yp_0[codeLen_0];
        _array__4zh2yp_0[codeLen_0] = _unary__edvuaz + 1 | 0;
        this.r22_1[_unary__edvuaz] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this.j22_1;
        var OFFSET = this.p22_1[i];
        var SIZE = this.o22_1[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this.r22_1[OFFSET + j | 0]);
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression.b2_1;
        var last = progression.c2_1;
        var step_0 = progression.d2_1;
        if (step_0 > 0 && inductionVariable_4 <= last || (step_0 < 0 && last <= inductionVariable_4))
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
          }
           while (!(j_0 === last));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 && !((oldCount % 2 | 0) === 0)) {
          // Inline function 'kotlin.error' call
          var message_0 = 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException.h5(toString(message_0));
        }
      }
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      // Inline function 'kotlin.error' call
      var message_1 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException.h5(toString(message_1));
    }
    this.k22_1 = allocNode(this, this.j22_1 - 2 | 0, this.j22_1 - 1 | 0);
    this.l22_1 = ncodes;
    computeFastLookup(this);
    return this;
  }
  o23(codeLengths, start, end, $super) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? codeLengths.length : end;
    return $super === VOID ? this.q23(codeLengths, start, end) : $super.q23.call(this, codeLengths, start, end);
  }
}
class SlidingWindow {
  constructor(nbits) {
    this.x23_1 = nbits;
    this.y23_1 = new Int8Array(1 << this.x23_1);
    this.z23_1 = this.y23_1.length - 1 | 0;
    this.a24_1 = 0;
  }
  e1(offset) {
    return this.y23_1[(this.a24_1 - offset | 0) & this.z23_1] & 255;
  }
  b24(offset) {
    return this.d24(this.e1(offset));
  }
  d24(value) {
    this.y23_1[this.a24_1] = toByte(value);
    this.a24_1 = (this.a24_1 + 1 | 0) & this.z23_1;
    return value;
  }
  c24(bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.d24(get_unsigned(bytes[offset + n | 0]));
      }
       while (inductionVariable < len);
  }
}
class FixedSizeByteArrayBuilder {
  static k24(data) {
    var $this = createThis(this);
    $this.a23_1 = data;
    $this.b23_1 = 0;
    return $this;
  }
  static w23(size) {
    return this.k24(new Int8Array(size));
  }
  k3() {
    this.b23_1 = 0;
  }
  ru(array, offset, len) {
    arraycopy(array, offset, this.a23_1, this.b23_1, len);
    this.b23_1 = this.b23_1 + len | 0;
  }
  tu(v) {
    var _unary__edvuaz = this.b23_1;
    this.b23_1 = _unary__edvuaz + 1 | 0;
    this.a23_1[_unary__edvuaz] = v;
  }
}
class Companion_2 {
  constructor() {
    this.l24_1 = 8388608;
    this.m24_1 = 32768;
  }
}
class BitReader {
  constructor(s, bigChunkSize, readWithSize) {
    bigChunkSize = bigChunkSize === VOID ? 8388608 : bigChunkSize;
    readWithSize = readWithSize === VOID ? 32768 : readWithSize;
    this.n24_1 = s;
    this.o24_1 = bigChunkSize;
    this.p24_1 = readWithSize;
    this.q24_1 = 0;
    this.r24_1 = 0;
    this.s24_1 = new SimpleRingBuffer(ilog2(get_nextPowerOfTwo(this.o24_1)));
    this.t24_1 = 0.0;
    this.u24_1 = 0.0;
    this.v24_1 = new Int8Array(4);
  }
  toString() {
    return 'BitReader(' + toString(this.n24_1) + ', bigChunkSize=' + this.o24_1 + ', readWithSize=' + this.p24_1 + ')';
  }
  y24() {
    return this.s24_1.o15_1 < this.p24_1;
  }
  w24(expectedBytes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBytesUpTo__5zpo26.bind(VOID, this, expectedBytes), $completion);
  }
  g24(bitcount) {
    while (this.r24_1 < bitcount) {
      var tmp = this;
      var tmp_0 = this.q24_1;
      // Inline function 'korlibs.compression.deflate.BitReader._su8' call
      this.t24_1 = this.t24_1 + 1;
      tmp.q24_1 = tmp_0 | this.s24_1.n16() << this.r24_1;
      this.r24_1 = this.r24_1 + 8 | 0;
    }
  }
  h24(bitcount) {
    return this.q24_1 & ((1 << bitcount) - 1 | 0);
  }
  i24(bitcount) {
    this.q24_1 = this.q24_1 >>> bitcount | 0;
    this.r24_1 = this.r24_1 - bitcount | 0;
  }
  f23(bitcount) {
    this.g24(bitcount);
    var readed = this.h24(bitcount);
    this.i24(bitcount);
    return readed;
  }
  e23() {
    return !(this.f23(1) === 0);
  }
  z24(count, out) {
    var offset = 0;
    var count_0 = count;
    if (this.r24_1 >= 8) {
      if (!((this.r24_1 % 8 | 0) === 0)) {
        var bits = this.r24_1 % 8 | 0;
        this.i24(bits);
      }
      while (this.r24_1 >= 8) {
        var byte = toByte(this.f23(8));
        var _unary__edvuaz = offset;
        offset = _unary__edvuaz + 1 | 0;
        out[_unary__edvuaz] = byte;
        count_0 = count_0 - 1 | 0;
      }
    }
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.q24_1 = 0;
    this.r24_1 = 0;
    var readCount = this.s24_1.y15(out, offset, count_0);
    if (readCount > 0)
      this.t24_1 = this.t24_1 + readCount;
  }
  x24(count, out) {
    this.z24(count, out);
    return out;
  }
  a25() {
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
    this.q24_1 = 0;
    this.r24_1 = 0;
    this.t24_1 = this.t24_1 + 1;
    return this.s24_1.n16();
  }
  t23() {
    this.z24(2, this.v24_1);
    return getU16LE(this.v24_1, 0);
  }
  b25() {
    this.z24(4, this.v24_1);
    return getS32LE(this.v24_1, 0);
  }
  c25() {
    this.z24(4, this.v24_1);
    return getS32BE(this.v24_1, 0);
  }
  d25(count, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_abytes__gje57m.bind(VOID, this, count, out), $completion);
  }
  e25(count, out, $completion, $super) {
    out = out === VOID ? new Int8Array(count) : out;
    return $super === VOID ? this.d25(count, out, $completion) : $super.d25.call(this, count, out, $completion);
  }
  v1r(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, buffer, offset, len), $completion);
  }
  w1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, this), $completion);
  }
  f25($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_strz__qhnc5d.bind(VOID, this), $completion);
  }
  d1v($completion) {
    return numberToLong(this.t24_1);
  }
  m1u($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8.bind(VOID, this), $completion);
  }
  l1u($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94.bind(VOID, this), $completion);
  }
}
class toDeflater$1 {
  constructor($this_toDeflater) {
    this.g25_1 = $this_toDeflater;
  }
  t22() {
    return this.g25_1.o24_1;
  }
  u22() {
    return this.g25_1.p24_1;
  }
  j24() {
    return this.g25_1.r24_1;
  }
  g24(bits) {
    return this.g25_1.g24(bits);
  }
  u23(count, $completion) {
    return this.g25_1.e25(count, VOID, $completion);
  }
  t23() {
    return this.g25_1.t23();
  }
  e23() {
    return this.g25_1.e23();
  }
  i24(bits) {
    return this.g25_1.i24(bits);
  }
  h24(count) {
    return this.g25_1.h24(count);
  }
  f23(count) {
    return this.g25_1.f23(count);
  }
  d23($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_prepareBigChunkIfRequired__yhuuys.bind(VOID, this), $completion);
  }
}
class toDeflater$2 {
  constructor($this_toDeflater) {
    this.h25_1 = $this_toDeflater;
  }
  t1r(bytes, offset, size, $completion) {
    return this.h25_1.t1r(bytes, offset, size, $completion);
  }
}
class uncompressStream$slambda {
  constructor($this_uncompressStream, $input) {
    this.i25_1 = $this_uncompressStream;
    this.j25_1 = $input;
  }
  k25(output, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, output), $completion);
  }
  de(p1, $completion) {
    return this.k25((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class uncompress$slambda {
  constructor($this_uncompress, $i, $o) {
    this.l25_1 = $this_uncompress;
    this.m25_1 = $i;
    this.n25_1 = $o;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class GZIPBase {
  constructor(checkCrc, deflater) {
    this.o25_1 = checkCrc;
    this.p25_1 = deflater;
  }
  toString() {
    return 'GZIPBase(' + this.o25_1 + ', ' + toString(this.p25_1) + ')';
  }
  f24(i, out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_1.bind(VOID, this, i, out), $completion);
  }
}
class GZIP extends GZIPBase {
  constructor(deflater) {
    Companion_getInstance_3();
    super(true, deflater);
  }
}
class Companion_3 extends GZIP {
  constructor() {
    Companion_instance_3 = null;
    super(GZIP$Companion$_init_$lambda_4zsoc7);
    Companion_instance_3 = this;
  }
  toString() {
    return 'GZIP';
  }
}
class GZIPBase$uncompress$2 {
  constructor($out, $ccrc32, $csize) {
    this.r25_1 = $out;
    this.s25_1 = $ccrc32;
    this.t25_1 = $csize;
    this.q25_1 = $out;
  }
  w1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_0.bind(VOID, this), $completion);
  }
  t1r(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l.bind(VOID, this, buffer, offset, len), $completion);
  }
}
class ZLib {
  constructor(deflater) {
    Companion_getInstance_4();
    this.w25_1 = deflater;
  }
  f24(i, o, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_uncompress__ej2bxp_2.bind(VOID, this, i, o), $completion);
  }
}
class Companion_4 extends ZLib {
  constructor() {
    Companion_instance_4 = null;
    super(ZLib$Companion$_init_$lambda_nrgg4o);
    Companion_instance_4 = this;
  }
}
class ZLib$uncompress$2 {
  constructor($o, $chash) {
    this.u25_1 = $o;
    this.v25_1 = $chash;
  }
  w1r($completion) {
    return this.u25_1.w1r($completion);
  }
  t1r(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0.bind(VOID, this, buffer, offset, len), $completion);
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function resetAlloc($this) {
  $this.j22_1 = 0;
}
function alloc($this, value, left, right) {
  // Inline function 'kotlin.apply' call
  var _unary__edvuaz = $this.j22_1;
  $this.j22_1 = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.compression.deflate.HuffmanTree.alloc.<anonymous>' call
  $this.g22_1[_unary__edvuaz] = value;
  $this.h22_1[_unary__edvuaz] = left;
  $this.i22_1[_unary__edvuaz] = right;
  return _unary__edvuaz;
}
function allocLeaf($this, value) {
  return alloc($this, value, 1023, 1023);
}
function allocNode($this, left, right) {
  return alloc($this, -1, left, right);
}
function computeFastLookup($this) {
  fill($this.m22_1, -1);
  computeEncodedValues($this, $this.k22_1, 0, 0);
}
function computeEncodedValues($this, node, encoded, encodedBits) {
  // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
  if ($this.g22_1[node] === -1) {
    if (encodedBits < 10) {
      // Inline function 'korlibs.compression.deflate.HuffmanTree.left' call
      var tmp$ret$1 = $this.h22_1[node];
      computeEncodedValues($this, tmp$ret$1, encoded, encodedBits + 1 | 0);
      // Inline function 'korlibs.compression.deflate.HuffmanTree.right' call
      var tmp$ret$2 = $this.i22_1[node];
      computeEncodedValues($this, tmp$ret$2, encoded | 1 << encodedBits, encodedBits + 1 | 0);
    } else {
      writeVariants($this, encoded, encodedBits, node, -2);
    }
  } else {
    // Inline function 'korlibs.compression.deflate.HuffmanTree.value' call
    var tmp$ret$3 = $this.g22_1[node];
    writeVariants($this, encoded, encodedBits, node, tmp$ret$3);
  }
}
function writeVariants($this, encoded, encodedBits, node, nvalue) {
  var encodedInfo = nvalue & 65535 | encodedBits << 16;
  var rangeCount = 1 << (10 - encodedBits | 0);
  var inductionVariable = 0;
  if (inductionVariable < rangeCount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = encoded | n << encodedBits;
      $this.m22_1[i] = encodedInfo;
      $this.n22_1[i] = node;
    }
     while (inductionVariable < rangeCount);
}
function *_generator_uncompress__ej2bxp($this, reader, out, $completion) {
  var sout = new SlidingWindowWithOutput(new SlidingWindow($this.s22_1), out, reader.t22(), reader.u22());
  var lastBlock = false;
  var tempTree = new HuffmanTree();
  var tempDist = new HuffmanTree();
  var codeLenCodeLen = new Int32Array(32);
  var lengths = new Int32Array(512);
  while (!lastBlock) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
    if (false || sout.c23()) {
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
      var tmp = sout.w22_1.t1r(sout.z22_1.a23_1, 0, sout.z22_1.b23_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      sout.z22_1.k3();
    }
    var tmp_0 = reader.d23($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    lastBlock = reader.e23();
    var blockType = reader.f23(2);
    if (!(0 <= blockType ? blockType <= 2 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'invalid bit';
      throw IllegalStateException.h5(toString(message));
    }
    if (blockType === 0) {
      var len = reader.t23();
      var nlen = reader.t23();
      var nnlen = ~nlen & 65535;
      if (!(len === nnlen)) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Invalid deflate stream: len(' + len + ') != ~nlen(' + nnlen + ') :: nlen=' + nlen;
        throw IllegalStateException.h5(toString(message_0));
      }
      var tmp_1 = reader.u23(len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bytes = tmp_1;
      sout.v23(bytes, 0, len);
      // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
      if (false || sout.c23()) {
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
        var tmp_2 = sout.w22_1.t1r(sout.z22_1.a23_1, 0, sout.z22_1.b23_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        sout.z22_1.k3();
      }
    } else {
      var tree;
      var dist;
      if (blockType === 1) {
        tree = Companion_getInstance_1().h23_1;
        dist = Companion_getInstance_1().i23_1;
      } else {
        var hlit = reader.f23(5) + 257 | 0;
        var hdist = reader.f23(5) + 1 | 0;
        var hclen = reader.f23(4) + 4 | 0;
        fill(codeLenCodeLen, 0);
        var inductionVariable = 0;
        if (inductionVariable < hclen)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            codeLenCodeLen[Companion_getInstance_1().n23_1[i]] = reader.f23(3);
          }
           while (inductionVariable < hclen);
        tempTree.o23(codeLenCodeLen);
        var codeLen = tempTree;
        var hlithdist = hlit + hdist | 0;
        var n = 0;
        fill(lengths, 0);
        while (n < hlithdist) {
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var value = codeLen.p23(reader);
          if (!(0 <= value ? value <= 18 : false)) {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.h5(toString('Invalid'));
          }
          var len_0;
          switch (value) {
            case 16:
              len_0 = reader.f23(2) + 3 | 0;
              break;
            case 17:
              len_0 = reader.f23(3) + 3 | 0;
              break;
            case 18:
              len_0 = reader.f23(7) + 11 | 0;
              break;
            default:
              len_0 = 1;
              break;
          }
          var vv;
          switch (value) {
            case 16:
              vv = lengths[n - 1 | 0];
              break;
            case 17:
              vv = 0;
              break;
            case 18:
              vv = 0;
              break;
            default:
              vv = value;
              break;
          }
          fill(lengths, vv, n, n + len_0 | 0);
          n = n + len_0 | 0;
        }
        tempTree.q23(lengths, 0, hlit);
        tempDist.q23(lengths, hlit, hlithdist);
        tree = tempTree;
        dist = tempDist;
      }
      $l$loop: while (true) {
        var tmp_3 = reader.d23($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var value_0 = tree.p23(reader);
        if (value_0 === 256)
          break $l$loop;
        if (value_0 < 256) {
          sout.s23(toByte(value_0));
        } else {
          var zlenof = value_0 - 257 | 0;
          var lengthExtra = reader.f23(Companion_getInstance_1().j23_1[zlenof]);
          // Inline function 'korlibs.compression.deflate.DeflaterPortable.read' call
          var distanceData = dist.p23(reader);
          var distanceExtra = reader.f23(Companion_getInstance_1().l23_1[distanceData]);
          var distance = Companion_getInstance_1().m23_1[distanceData] + distanceExtra | 0;
          var length = Companion_getInstance_1().k23_1[zlenof] + lengthExtra | 0;
          sout.r23(distance, length);
        }
        // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
        if (false || sout.c23()) {
          // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
          var tmp_4 = sout.w22_1.t1r(sout.z22_1.a23_1, 0, sout.z22_1.b23_1, $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
          sout.z22_1.k3();
        }
      }
    }
  }
  // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flushIfRequired' call
  if (true || sout.c23()) {
    // Inline function 'korlibs.compression.deflate.SlidingWindowWithOutput.flush' call
    var tmp_5 = sout.w22_1.t1r(sout.z22_1.a23_1, 0, sout.z22_1.b23_1, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    sout.z22_1.k3();
  }
  return Unit_instance;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 255;
}
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function toDeflater(_this__u8e3s4) {
  return new toDeflater$1(_this__u8e3s4);
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function *_generator_prepareBytesUpTo__5zpo26($this, expectedBytes, $completion) {
  $l$loop_0: while ($this.s24_1.o15_1 < expectedBytes) {
    // Inline function 'kotlin.math.min' call
    var b = $this.s24_1.k16();
    var readCount = Math.min(expectedBytes, b);
    if (readCount <= 0)
      break $l$loop_0;
    var tmp = $this.n24_1.v1r($this.s24_1.e16(), $this.s24_1.g16(), readCount, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var transferred = tmp;
    if (transferred <= 0)
      break $l$loop_0;
    $this.s24_1.h16(transferred);
    $this.u24_1 = $this.u24_1 + transferred;
  }
  return Unit_instance;
}
function *_generator_abytes__gje57m($this, count, out, $completion) {
  var tmp = $this.w24(count, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.x24(count, out);
}
function *_generator_read__qih2oe($this, buffer, offset, len, $completion) {
  var tmp = $this.w24(len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var out = $this.s24_1.y15(buffer, offset, len);
  $this.t24_1 = $this.t24_1 + out;
  return out;
}
function *_generator_close__nh2uv0($this, $completion) {
  var tmp = $this.n24_1.w1r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_strz__qhnc5d($this, $completion) {
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.pu(4096);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.compression.deflate.BitReader.strz.<anonymous>' call
  // Inline function 'korlibs.compression.deflate.BitReader.discardBits' call
  $this.q24_1 = 0;
  $this.r24_1 = 0;
  $l$loop: while (true) {
    // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
    if ($this.y24()) {
      var tmp = $this.w24($this.o24_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
    // Inline function 'korlibs.compression.deflate.BitReader._su8' call
    $this.t24_1 = $this.t24_1 + 1;
    var c = $this.s24_1.n16();
    if (c === 0)
      break $l$loop;
    write8(s, c);
  }
  var tmp$ret$2 = buffer.uu();
  return toString_0(tmp$ret$2, ASCII_getInstance());
}
function *_generator_hasLength__5f5ox8($this, $completion) {
  var tmp = $this.n24_1;
  var tmp2_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp2_safe_receiver.m1u($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function *_generator_getLength__lvva94($this, $completion) {
  var tmp = $this.n24_1;
  var tmp3_safe_receiver = isInterface(tmp, AsyncGetLengthStream) ? tmp : null;
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp_1 = tmp3_safe_receiver.l1u($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var message = 'Length not available on Stream';
    throw IllegalStateException.h5(toString(message));
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function toDeflater_0(_this__u8e3s4) {
  return new toDeflater$2(_this__u8e3s4);
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function get_nextPowerOfTwo(_this__u8e3s4) {
  var v = _this__u8e3s4;
  v = v - 1 | 0;
  v = v | v >> 1;
  v = v | v >> 2;
  v = v | v >> 4;
  v = v | v >> 8;
  v = v | v >> 16;
  v = v + 1 | 0;
  return v;
}
function *_generator_prepareBigChunkIfRequired__yhuuys($this, $completion) {
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  var this_0 = $this.g25_1;
  if (this_0.y24()) {
    var tmp = this_0.w24(this_0.o24_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp_0($this, i, o, $completion) {
  var tmp = $this.e24(toDeflater(new BitReader(i)), toDeflater_0(o), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressed(_this__u8e3s4, method, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  return uncompressStream(method, _this__u8e3s4, bufferSize, $completion);
}
function uncompress_1(_this__u8e3s4, method, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(_this__u8e3s4.length, 2) : outputSizeHint;
  return uncompress_2(method, _this__u8e3s4, outputSizeHint);
}
function uncompressStream(_this__u8e3s4, input, bufferSize, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  var tmp = 'uncompress:' + toString(_this__u8e3s4);
  return asyncStreamWriter(bufferSize, tmp, false, uncompressStream$slambda_0(_this__u8e3s4, input), $completion);
}
function uncompress_2(_this__u8e3s4, bytes, outputSizeHint) {
  outputSizeHint = outputSizeHint === VOID ? imul(bytes.length, 2) : outputSizeHint;
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.pu(outputSizeHint);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.io.compression.uncompress.<anonymous>' call
  uncompress_3(_this__u8e3s4, openSync(bytes), s);
  return buffer.uu();
}
function uncompress_3(_this__u8e3s4, i, o) {
  return runBlockingNoSuspensions(uncompress$slambda_0(_this__u8e3s4, i, o));
}
function *_generator_invoke__zhh2q8($this, output, $completion) {
  var tmp = $this.i25_1.f24($this.j25_1, output, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompressStream$slambda_0($this_uncompressStream, $input) {
  var i = new uncompressStream$slambda($this_uncompressStream, $input);
  var l = function (output, $completion) {
    return i.k25(output, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.l25_1.f24(toAsync($this.m25_1), toAsync_0($this.n25_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function uncompress$slambda_0($this_uncompress, $i, $o) {
  var i = new uncompress$slambda($this_uncompress, $i, $o);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function get_Deflate() {
  _init_properties_Deflate_kt__jbr9mv();
  // Inline function 'kotlin.getValue' call
  var this_0 = Deflate$delegate;
  Deflate$factory();
  return this_0.s1();
}
var Deflate$delegate;
function Deflate(windowBits) {
  _init_properties_Deflate_kt__jbr9mv();
  return DeflaterNative(windowBits);
}
function Deflate$delegate$lambda() {
  _init_properties_Deflate_kt__jbr9mv();
  return Deflate(15);
}
function Deflate$factory() {
  return getPropertyCallableRef('Deflate', 0, KProperty0, function () {
    return get_Deflate();
  }, null);
}
var properties_initialized_Deflate_kt_5ek8zp;
function _init_properties_Deflate_kt__jbr9mv() {
  if (!properties_initialized_Deflate_kt_5ek8zp) {
    properties_initialized_Deflate_kt_5ek8zp = true;
    Deflate$delegate = lazy(Deflate$delegate$lambda);
  }
}
function GZIP$Companion$_init_$lambda_4zsoc7() {
  return get_Deflate();
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function *_generator_close__nh2uv0_0($this, $completion) {
  var tmp = $this.q25_1.w1r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_write__x1694l($this, buffer, offset, len, $completion) {
  if (len > 0) {
    $this.s25_1._v = CRC32_getInstance().t21($this.s25_1._v, buffer, offset, len);
    $this.t25_1._v = $this.t25_1._v + len | 0;
    var tmp = $this.r25_1.t1r(buffer, offset, len, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_uncompress__ej2bxp_1($this, i, out, $completion) {
  var r = new BitReader(i);
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.y24()) {
    var tmp = r.w24(r.o24_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var h0 = r.a25();
  var h1 = r.a25();
  if (!(h0 === 31) || !(h1 === 139)) {
    // Inline function 'kotlin.error' call
    var message = 'Not a GZIP file (h0=' + toHexString(toByte(h0)) + ', h1=' + toHexString(toByte(h1)) + ')';
    throw IllegalStateException.h5(toString(message));
  }
  var method = r.a25();
  if (!(method === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Just supported deflate in GZIP (method=' + method + ')';
    throw IllegalStateException.h5(toString(message_0));
  }
  var ftext = r.e23();
  var fhcrc = r.e23();
  var fextra = r.e23();
  var fname = r.e23();
  var fcomment = r.e23();
  var reserved = r.f23(3);
  var mtime = r.b25();
  var xfl = r.a25();
  var os = r.a25();
  var tmp_0;
  if (fextra) {
    var tmp_1 = r.e25(r.t23(), VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0 = new Int8Array([]);
  }
  var extra = tmp_0;
  var tmp_2;
  if (fname) {
    var tmp_3 = r.f25($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = null;
  }
  var name = tmp_2;
  var tmp_4;
  if (fcomment) {
    var tmp_5 = r.f25($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp_4 = tmp_5;
  } else {
    tmp_4 = null;
  }
  var comment = tmp_4;
  var crc16 = fhcrc ? r.t23() : 0;
  var ccrc32 = {_v: CRC32_getInstance().u21_1};
  var csize = {_v: 0};
  var tmp_6 = $this.p25_1();
  var tmp_7 = isInterface(tmp_6, IDeflaterInternal) ? tmp_6 : THROW_CCE();
  var tmp_8 = toDeflater(r);
  var tmp_9 = tmp_7.e24(tmp_8, toDeflater_0(new GZIPBase$uncompress$2(out, ccrc32, csize)), $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.y24()) {
    var tmp_10 = r.w24(r.o24_1, $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  var crc32 = r.b25();
  var size = r.b25();
  if ($this.o25_1 && (!(csize._v === size) || !(ccrc32._v === crc32))) {
    invalidOp("Size doesn't match SIZE(" + toHexString_0(csize._v) + ' != ' + toHexString_0(size) + ') || CRC32(' + toHexString_0(ccrc32._v) + ' != ' + toHexString_0(crc32) + ')');
  }
  return Unit_instance;
}
function ZLib$Companion$_init_$lambda_nrgg4o(it) {
  return Deflate(it);
}
function *_generator_write__x1694l_0($this, buffer, offset, len, $completion) {
  var tmp = $this.u25_1.t1r(buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.v25_1._v = Adler32_instance.t21($this.v25_1._v, buffer, offset, len);
  return Unit_instance;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function *_generator_uncompress__ej2bxp_2($this, i, o, $completion) {
  var r = new BitReader(i);
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.y24()) {
    var tmp = r.w24(r.o24_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var cmf = r.a25();
  var flg = r.a25();
  if (!(((imul(cmf, 256) + flg | 0) % 31 | 0) === 0)) {
    // Inline function 'kotlin.error' call
    var message = 'bad zlib header';
    throw IllegalStateException.h5(toString(message));
  }
  var compressionMethod = extract(cmf, 0, 4);
  if (!(compressionMethod === 8)) {
    // Inline function 'kotlin.error' call
    var message_0 = 'Invalid zlib stream compressionMethod=' + compressionMethod;
    throw IllegalStateException.h5(toString(message_0));
  }
  var windowBits = extract(cmf, 4, 4) + 8 | 0;
  var fcheck = extract(flg, 0, 5);
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  var hasDict = !(((flg >>> 5 | 0) & 1) === 0);
  var flevel = extract(flg, 6, 2);
  var dictid = 0;
  if (hasDict) {
    dictid = r.b25();
    // Inline function 'kotlin.TODO' call
    var reason = 'Unsupported custom dictionaries (Provided DICTID=' + dictid + ')';
    throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  var chash = {_v: Adler32_instance.s21_1};
  var tmp_0 = $this.w25_1(windowBits);
  var tmp_1 = isInterface(tmp_0, IDeflaterInternal) ? tmp_0 : THROW_CCE();
  var tmp_2 = toDeflater(r);
  var tmp_3 = tmp_1.e24(tmp_2, toDeflater_0(new ZLib$uncompress$2(o, chash)), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'korlibs.compression.deflate.BitReader.prepareBigChunkIfRequired' call
  if (r.y24()) {
    var tmp_4 = r.w24(r.o24_1, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  var adler32 = r.c25();
  if (!(chash._v === adler32)) {
    invalidOp("Adler32 doesn't match " + toHexString_0(chash._v) + ' != ' + toHexString_0(adler32));
  }
  return Unit_instance;
}
function DeflaterNative(windowBits) {
  return new DeflaterPortable(windowBits);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SlidingWindowWithOutput, 'SlidingWindowWithOutput', VOID, VOID, VOID, [0, 1]);
initMetadataForInterface(CompressionMethod, 'CompressionMethod', VOID, VOID, VOID, [2, 3]);
initMetadataForInterface(IDeflaterInternal, 'IDeflaterInternal', VOID, VOID, [CompressionMethod], [2, 3]);
protoOf(DeflaterPortable).f24 = uncompress_0;
initMetadataForClass(DeflaterPortable, 'DeflaterPortable', VOID, VOID, [IDeflaterInternal], [3, 2]);
initMetadataForCompanion(Companion_1, VOID, VOID, [3, 2]);
initMetadataForClass(HuffmanTree, 'HuffmanTree', HuffmanTree);
initMetadataForClass(SlidingWindow, 'SlidingWindow');
initMetadataForClass(FixedSizeByteArrayBuilder, 'FixedSizeByteArrayBuilder');
initMetadataForCompanion(Companion_2, VOID, VOID, [1]);
initMetadataForClass(BitReader, 'BitReader', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1, 2, 3]);
initMetadataForClass(toDeflater$1, VOID, VOID, VOID, VOID, [0, 1, 3]);
initMetadataForClass(toDeflater$2, VOID, VOID, VOID, VOID, [3, 1]);
initMetadataForLambda(uncompressStream$slambda, VOID, VOID, [1]);
initMetadataForLambda(uncompress$slambda, VOID, VOID, [0]);
initMetadataForClass(GZIPBase, 'GZIPBase', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForClass(GZIP, 'GZIP', VOID, VOID, VOID, [2, 3]);
initMetadataForCompanion(Companion_3, VOID, VOID, [2, 3]);
protoOf(GZIPBase$uncompress$2).u1r = write$default;
initMetadataForClass(GZIPBase$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [1, 0, 3]);
initMetadataForClass(ZLib, 'ZLib', VOID, VOID, [CompressionMethod], [2, 3]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 3]);
protoOf(ZLib$uncompress$2).u1r = write$default;
initMetadataForClass(ZLib$uncompress$2, VOID, VOID, VOID, [AsyncOutputStream], [0, 3, 1]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
export {
  uncompressed as uncompressed1upyct1udgysk,
  Companion_getInstance_3 as Companion_getInstance21eog9dvyf17t,
  Companion_getInstance_4 as Companion_getInstance3mocpl8hga9iq,
  get_Deflate as get_Deflate2a0lyute7oxjd,
  uncompress_1 as uncompress3ofkd276wd0zn,
};
//endregion
